// frontend/src/components/leaderboard/LeagueCard.tsx

import { useEffect, useState } from 'react';
import { authService } from '../../services/auth.service';

const API_BASE = (import.meta.env.PROD && (import.meta.env.VITE_API_BASE_URL === 'http://localhost:8080' || !import.meta.env.VITE_API_BASE_URL)) ? '' : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080');

interface LeagueData {
  league: { name: string; icon: string; min: number; max: number | null };
  members: { rank: number; displayName: string; schoolName?: string | null; xp: number; isCurrentUser: boolean }[];
}

export function LeagueCard() {
  const [data, setData] = useState<LeagueData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    authService.getAccessToken().then(async (token) => {
      // Token yoksa hiç istek atma ve yükleme durumunu bitir
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const res = await fetch(`${API_BASE}/api/leaderboard/league`, { 
          headers: { Authorization: `Bearer ${token}` } 
        });

        // Sunucudan 200 OK harici bir yanıt dönerse hata fırlat
        if (!res.ok) {
          throw new Error(`HTTP Hata: ${res.status}`);
        }

        const jsonData = await res.json();
        setData(jsonData);
      } catch (error) {
        console.error("Lig verisi çekilemedi:", error);
        setData(null); // Çökmeyi önlemek için data null kalır
      } finally {
        setIsLoading(false);
      }
    });
  }, []);

  if (isLoading) return <div className="card courses-loading">Yükleniyor...</div>;
  
  // Data gelmediyse, league objesi yoksa veya members dizisi yoksa bileşeni çizme
  if (!data || !data.league || !data.members) return null;

  return (
    <div className="card" style={{ marginBottom: 24, borderLeft: '4px solid var(--accent)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
        <span style={{ fontSize: 32 }}>{data.league.icon}</span>
        <div>
          <h3 style={{ fontSize: 18, fontWeight: 800 }}>{data.league.name} Lig</h3>
          <p style={{ fontSize: 13, color: 'var(--gray)' }}>
            {data.league.min} - {data.league.max ?? '∞'} XP aralığı
          </p>
        </div>
      </div>
      {data.members.map((m) => (
        <div key={m.rank} className="leaderboard-item" style={m.isCurrentUser ? { background: 'rgba(99,102,241,0.05)', borderRadius: 'var(--radius)' } : undefined}>
          <div className="leaderboard-rank normal">{m.rank}</div>
          <div className="leaderboard-info">
            <h4>{m.displayName}{m.isCurrentUser && ' (Sen)'}</h4>
            {m.schoolName && <p style={{ fontSize: 11, color: 'var(--gray)', margin: 0 }}>{m.schoolName}</p>}
          </div>
          <div className="league-xp-pill">
            <span className="xp-lightning-icon">⚡</span>
            <span className="xp-value">{m.xp.toLocaleString('tr-TR')}</span>
            <span className="xp-label">XP</span>
          </div>
        </div>
      ))}
    </div>
  );
}